import { disabledGrey } from '$constants'
import { SvgIconComponent } from '@mui/icons-material'
import {
  IconButton,
  IconButtonProps,
  SvgIconOwnProps,
  Tooltip,
  TooltipProps,
} from '@mui/material'
import { FC, ReactNode } from 'react'

type LoadedIconButtonProps = {
  Icon: SvgIconComponent
  iconProps?: SvgIconOwnProps
  onClick?: () => void
  iconButtonProps?: IconButtonProps
  tooltipProps?: Omit<TooltipProps, 'children'>
}

const LoadedIconButton: FC<LoadedIconButtonProps> = ({
  Icon,
  onClick,
  iconProps,
  iconButtonProps,
  tooltipProps,
}) => {
  const CustomIconButton: ReactNode = (
    <IconButton
      sx={{
        color: disabledGrey,
        paddingY: '0rem',
        '&:hover': {
          color: 'text.secondary',
        },
        ...iconButtonProps?.sx,
      }}
      disableRipple
      onClick={onClick}
      {...iconButtonProps}
    >
      <Icon fontSize="small" {...iconProps} />
    </IconButton>
  )

  if (tooltipProps?.title) {
    return (
      <Tooltip arrow placement="top" {...tooltipProps}>
        {CustomIconButton}
      </Tooltip>
    )
  }

  return CustomIconButton
}

export default LoadedIconButton
